"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function findCommonStrings() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var arrays = [].concat(args);
  return arrays.shift().reduce(function (common, current) {
    if (common.indexOf(current) === -1 && arrays.every(function (array) {
      return array.indexOf(current) !== -1;
    })) {
      common.push(current);
    }

    return common;
  }, []);
}

var _default = findCommonStrings;
exports["default"] = _default;